export default __webpack_public_path__ + "92db3ffa2e616156885806763535d985.png";